import MsNavbar from './MsNavbar.vue';
import MsFooter from './MsFooter.vue';
import Pagination from './Pagination/index.vue';
import SvgIcon from './SvgIcon/index.vue';
import MsTabs from './MsTabs.vue';
import MsSiderBar from './MsSiderBar.vue';
import MsSiderBarBox from './MsSiderBarBox.vue';
import MsUserNav from "./MsUserNav.vue";
import MaterialCheck from "./MaterialCheck.vue";
import MaterialCheckBox from "./MaterialCheckBox.vue";

export default {
  install (app) {
    app.component(MsNavbar.name, MsNavbar)
    app.component(MsFooter.name, MsFooter)
    app.component(Pagination.name, Pagination)
    app.component(SvgIcon.name, SvgIcon)
    app.component(MsTabs.name, MsTabs)
    app.component(MsSiderBar.name, MsSiderBar)
    app.component(MsSiderBarBox.name, MsSiderBarBox)
    app.component(MsUserNav.name, MsUserNav)
    app.component(MaterialCheck.name, MaterialCheck)
    app.component(MaterialCheckBox.name, MaterialCheckBox)
  }
}